<template>
  <TransitionRoot appear :show="open" as="template">
    <Dialog as="div" @close="setIsOpen" class="relative z-999" static>
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/50" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto z-500">
        <div class="flex min-h-full items-center justify-center p-4 md:p-6 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full transform rounded-2xl bg-white dark:bg-gray-900 text-left align-middle shadow-xl transition-all relative"
              :class="large ? 'max-w-5xl' : 'max-w-2xl'"
            >
              <DialogTitle
                v-if="title"
                as="h3"
                class="pl-8 pt-4 text-xl font-medium leading-6 text-secondary"
              >
                <slot name="title">{{ title }}</slot>
              </DialogTitle>
              <div class=" p-4 md:p-8">
                <button
                  v-if="!closeBtn"
                  type="button"
                  class="cursor-pointer absolute top-3 right-3 inline-flex justify-center rounded-full border border-transparent p-1 text-sm font-medium text-secondary outline-hidden"
                  @click="$emit('close')"
                >
                  <BaseIcon
                    name="close"
                    size="14"
                    class="hover:rotate-90 transition-transform ease-in fill-dark-card dark:fill-white"
                  ></BaseIcon>
                </button>
                <slot />
              </div>

              <div class="mt-4 px-4 pb-4 flex justify-center gap-4" v-if="action">
                <button class="btn btn-outline-secondary min-w-[120px]" @click="$emit('close')">
                  Close
                </button>
                <slot name="action"></slot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

const emit = defineEmits(['close']);
const props = defineProps({
  open: Boolean,
  close: {
    type: Boolean,
    default: true,
  },
  closeBtn: {
    type: Boolean,
    default: false,
  },
  title: {
    type: Boolean,
    default: false,
  },
  action: {
    type: Boolean,
    default: false,
  },
  static: {
    type: Boolean,
    default: false,
  },
  large: {
    type: Boolean,
    default: false,
  },
});

// const isOpen = ref(true);

function setIsOpen(value) {
  if (value) {
    emit('close');
  }

  // isOpen.value = value;
}
</script>
